"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _componentsBase = require("@telus-uds/components-base");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SideButton = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    isEnabled = true,
    onPress = () => {},
    onDoubleClick = () => {},
    accessibilityLabel = '',
    accessibilityDisabled = false,
    tokens = {},
    variant = {}
  } = _ref;
  const getTokens = (0, _componentsBase.useThemeTokensCallback)('QuantitySelectorSideButton', tokens, variant);
  const getButtonTokens = _ref2 => {
    let {
      buttonState,
      disabled
    } = _ref2;
    const {
      borderRadius,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      ...rest
    } = getTokens({
      ...buttonState,
      disabled
    });
    return {
      ...rest,
      borderRadius,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      outerBorderRadius: borderRadius,
      outerBorderTopLeftRadius: borderTopLeftRadius,
      outerBorderTopRightRadius: borderTopRightRadius,
      outerBorderBottomLeftRadius: borderBottomLeftRadius,
      outerBorderBottomRightRadius: borderBottomRightRadius,
      outerBorderGap: 0,
      outerBorderWidth: 0
    };
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.IconButton, {
    tokens: buttonState => getButtonTokens({
      disabled: !isEnabled,
      buttonState
    }),
    onPress: onPress,
    onDoubleClick: onDoubleClick,
    accessibilityLabel: accessibilityLabel,
    accessibilityDisabled: accessibilityDisabled,
    ref: ref
  });
});
SideButton.displayName = 'QuantitySelectorSideButton';
SideButton.propTypes = {
  isEnabled: _propTypes.default.bool,
  onPress: _propTypes.default.func,
  onDoubleClick: _propTypes.default.func,
  accessibilityLabel: _propTypes.default.string,
  accessibilityDisabled: _propTypes.default.bool,
  tokens: (0, _componentsBase.getTokensPropType)('QuantitySelectorSideButton'),
  variant: _propTypes.default.object
};
var _default = exports.default = SideButton;